import { useEffect } from 'react';
import styles from './aboutus.module.css';

import constants from '../../../constants.js';

import { useSidebarProvider } from '../../../providers/SidebarProvider.js';


const AboutUs = ({setSelectedMenuItem}) => {
  const { setIsSidebarShowing } = useSidebarProvider();

  useEffect(() => {
    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }
    setSelectedMenuItem("");
  },[]);

  return (
    <div className={styles.AboutUs}>
      <div className={styles.Section1}>
        <div style={{paddingLeft: '2em'}}>
          <div className={styles.Title}>How It All Began...</div>
          <div className={styles.Text}>The Cross Club Pickleball League began with the realization that there was a gap to fill. While there are countless opportunities for social play and tournament competition, the Cross Club Pickleball League offers a unique competitive team format. The league provides tournament-like play in a structured environment, allowing players to represent their indoor clubs through weekly scheduled competitive matches against players of similar skill levels. Founded in 2023, CPL continues to grow, expanding throughout the Northeast and beyond. We are excited to bring this level of localized competitive play to pickleball players everywhere.</div>
      <br/>
        </div>
        
        <div className={styles.PicContainer} style={{backgroundImage: `url(pictures/AboutUs/Players-Courtyard-120.jpg)`}}>
          {/* <img style={{borderRadius:'32px', objectFit: 'contain'}} src='pictures/AboutUs/Players-Courtyard-120.jpg'/> */}
        </div>
      </div>
      <div className={styles.Section2}>
        <div className={`${styles.Content} ${styles.PicContent}`}>
          <img style={{height: 'auto', maxWidth: '100%', borderTopRightRadius: '32px', borderBottomRightRadius: '32px'}} 
            src='pictures/AboutUs/Players-Courtyard-4.jpg'/>
        </div>

        <div className={`${styles.Content} ${styles.TextContent}`}>
          <div className={styles.TextContent}>
            <div className={styles.SubTitle}>Our Mission</div>
            <div className={styles.Text}>To provide a competitive pickleball league where players represent their clubs through team-based competition, connecting through a structured club vs club format that welcomes players of all skill levels.</div>
          </div>
        </div>

         <div className={`${styles.Content} ${styles.TextContent}`}>
          <div className={styles.TextContent}>
            <div className={styles.SubTitle}>Our Vision</div>
            <div className={styles.Text}>To bring a club-centric league to players everywhere, unifying them through the experience of representing their club and empowering them to achieve collective success in competitive play.</div>
          </div>
        </div>
        
        <div className={`${styles.Content} ${styles.PicContent}`}>
          <img style={{height: 'auto', maxWidth: '100%', borderTopLeftRadius: '32px', borderBottomLeftRadius: '32px'}} 
            src='pictures/AboutUs/CPL-Finals-4.0-12.jpg'/>
        </div>

      </div>
<br/>
      {/* <div className={styles.Section3}>
        <div className={styles.SubTitle}>Our Team</div>
        <div style={{marginBottom:'2em'}}>Meet our dedicated team, passionate about enhancing pickleball experiences and fostering community through competitive play</div>
        <div className={styles.Employees}>
          <div className={styles.Employee}>
            <div className={styles.EmployeePic}></div>
            <div className={styles.EmployeeDesc}>
              <div style={{fontSize:'1.4rem', fontWeight:'500'}}>Employee Name</div>
              <div>Employee description</div>
            </div>
          </div>

          <div className={styles.Employee}>
            <div className={styles.EmployeePic}></div>
            <div className={styles.EmployeeDesc}>
              <div style={{fontSize:'1.4rem', fontWeight:'500'}}>Employee Name</div>
              <div>Employee description</div>
            </div>
          </div>

          <div className={styles.Employee}>
            <div className={styles.EmployeePic}></div>
            <div className={styles.EmployeeDesc}>
              <div style={{fontSize:'1.4rem', fontWeight:'500'}}>Employee Name</div>
              <div>Employee description</div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default AboutUs;